import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { formatTime } from '../../utils/date.util'

export default function GroupMessage({ message }) {
  const { currentUser } = useAuth()
  const isMine = message.senderId === currentUser.id

  return (
    <div className={`flex ${isMine ? 'justify-end' : 'justify-start'} mb-2`}>
      <div
        className={`p-3 rounded-xl max-w-[75%] shadow mb-2 ${
          isMine
            ? 'bg-blue-600 text-white rounded-br-none'
            : 'bg-background text-black rounded-bl-none'
        }`}
      >
        {message.message}
        <div className={`text-xs mt-1 text-right ${isMine ? 'text-blue-200' : 'text-gray-400'}`}>
          {formatTime(message.createdAt, false)}
        </div>
      </div>
    </div>
  )
}
